import { FC } from 'react';

import { isoToLocal } from '~/utils/date/date';
import { IClientTeam } from '~/services/api/clientDetails/types';
import ListItem from '~/ui/components/common/ListItem/ListItem';

import styles from './DischargeDetails.module.scss';

interface IProps {
  clientTeams: IClientTeam[];
  isArchivedClient?: boolean;
}

const DischargeDetails: FC<IProps> = ({ clientTeams, isArchivedClient }) => {
  const extractTeamDischargeInfo = (admissionDetails: IClientTeam['admissionDetails']) => [
    `Discharge Reason: ${admissionDetails.dischargeReason?.name}`,
    `Discharge Date: ${isoToLocal(admissionDetails.dischargeDate)}`,
  ];

  return (
    <div className={styles.dischargeDetails}>
      {isArchivedClient && <h4 className={styles.red}>ARCHIVED CLIENT</h4>}
      <div className={styles.listItemBlock}>
        <div className={styles.item}>
          <h4>Details of Discharge</h4>
        </div>
        {clientTeams.map(team => (
          <ListItem
            noActions
            key={team.id}
            label={team.team?.name}
            content={
              <div className={styles.descriptionWrapper}>
                {extractTeamDischargeInfo(team.admissionDetails).map(row => (
                  <div key={row} className={styles.grey}>
                    {row}
                  </div>
                ))}
              </div>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default DischargeDetails;
